<template>
  <header class="s-header">
    <div class="s-header__inside">
      <a href="/" class="s-header__logo" title="Přejít na úvodní stránku">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108 31.22">
          <desc>Logo safeside by anygence</desc>
          <g fill="#243762">
            <path
              d="M1.78 9.81H0V7.87h2.12l.25-1.58H.63V4.35h2.06L3.24.93h1.93L3.14 13.22H1.22l.56-3.41zM6.44.93h1.93l-.56 3.42h1.78v1.94H7.47l-.25 1.58h1.73v1.94H6.9l-.55 3.42H4.42L6.44.93zM17.08 13.43c-.84.02-1.68-.14-2.46-.46-.63-.25-1.18-.69-1.57-1.25l1.37-1.35c.32.38.72.69 1.16.91.48.22 1 .34 1.52.33.39.02.78-.06 1.14-.24.27-.14.44-.43.42-.73a.565.565 0 00-.28-.54c-.24-.12-.5-.2-.77-.24l-1.38-.23c-.37-.05-.72-.14-1.07-.27-.31-.11-.6-.28-.85-.5-.24-.22-.44-.48-.58-.77-.15-.35-.22-.73-.21-1.11-.04-.87.34-1.7 1.02-2.24a4.51 4.51 0 012.86-.81c.73-.02 1.45.1 2.13.36.55.22 1.04.57 1.41 1.03L19.73 6.8a3.044 3.044 0 00-2.41-1.04c-.94 0-1.42.31-1.42.92-.02.22.08.44.28.56.24.12.5.2.77.24l1.35.23c.36.05.72.15 1.07.27.32.11.61.28.87.5.25.21.45.48.58.77.15.35.22.73.21 1.11.03.87-.35 1.71-1.03 2.25-.84.6-1.88.89-2.92.82zM32.64 13.22c-.44.02-.88-.13-1.22-.41-.32-.31-.52-.74-.54-1.19h-.08c-.12.55-.45 1.04-.91 1.36-.5.32-1.08.48-1.67.46-.73.04-1.44-.22-1.99-.71-.52-.53-.79-1.26-.75-2-.06-.83.31-1.62.97-2.12a4.84 4.84 0 012.85-.69h1.37v-.46c.03-.44-.09-.87-.35-1.22-.32-.31-.76-.47-1.2-.42-.44-.02-.88.09-1.25.32-.33.22-.61.5-.82.83L25.72 5.7c.32-.54.78-.98 1.34-1.27.73-.36 1.54-.53 2.35-.5.98-.06 1.95.24 2.73.85.7.67 1.06 1.62.98 2.58v3.98h.94v1.88h-1.42zm-3.5-1.5c.39.01.77-.11 1.09-.33.3-.23.47-.59.44-.97V9.33h-1.3c-1 0-1.5.36-1.5 1.07v.35c-.02.28.12.56.35.72.27.19.59.27.92.25zM38.18 11.18h2.51v-5h-2.67V4.14h2.67V2.82c-.03-.69.2-1.36.63-1.89A2.5 2.5 0 0143.29.2h2.88v2.04h-3.05v1.9h3.05v2.05h-3.05v5h2.67v2.04h-7.62l.01-2.05zM54.57 13.44c-1.22.08-2.41-.38-3.24-1.27-.78-.98-1.17-2.2-1.1-3.45-.01-.68.09-1.35.29-2 .17-.55.45-1.07.82-1.52.35-.41.8-.74 1.3-.95.55-.22 1.13-.34 1.72-.33.59-.01 1.17.1 1.71.33.5.21.94.52 1.3.93.37.42.64.92.82 1.45.2.61.29 1.26.29 1.9v.78h-5.82v.16c-.08 1 .66 1.88 1.67 1.96.11.01.23.01.34 0 .45.01.9-.09 1.3-.31.36-.21.68-.49.94-.82l1.32 1.53c-.37.47-.85.86-1.38 1.13-.73.34-1.5.5-2.28.48zm-.2-7.65c-.48-.02-.94.17-1.27.52-.33.39-.5.89-.47 1.4v.14h3.43v-.14c.02-.51-.14-1.01-.46-1.41-.32-.34-.77-.53-1.23-.51zM66.62 13.43c-.84.02-1.68-.14-2.46-.46-.63-.25-1.18-.69-1.57-1.25l1.37-1.35c.32.38.71.69 1.16.91.48.22 1 .34 1.52.33.39.02.78-.06 1.14-.24.27-.14.44-.43.42-.73a.565.565 0 00-.28-.54c-.24-.12-.5-.2-.77-.24l-1.37-.23c-.37-.05-.72-.14-1.07-.27-.31-.11-.6-.28-.86-.5-.24-.22-.44-.48-.58-.77-.15-.35-.22-.73-.21-1.11-.04-.87.34-1.7 1.02-2.24.84-.59 1.85-.87 2.87-.81.73-.02 1.45.1 2.13.36.55.22 1.03.57 1.4 1.03L69.26 6.8c-.27-.31-.6-.56-.97-.74-.45-.21-.94-.31-1.43-.3-.94 0-1.42.31-1.42.92-.02.22.09.44.28.56.24.12.5.2.77.24l1.35.23c.37.05.72.15 1.07.27.31.11.6.28.86.5.25.21.45.48.58.77.15.35.22.73.21 1.11.03.87-.35 1.71-1.03 2.25-.84.6-1.87.89-2.91.82zM75.72 11.18h2.7v-5h-2.7V4.14h5.14v7.04h2.5v2.04h-7.64v-2.04zm3.92-8.2c-.42.05-.83-.08-1.14-.36-.21-.24-.33-.55-.32-.87v-.51c-.01-.32.11-.64.32-.88.69-.47 1.6-.47 2.29 0 .21.24.32.55.31.88v.51c.01.32-.11.63-.32.87-.31.27-.73.4-1.14.36zM93.03 11.55h-.11c-.2.52-.51.98-.92 1.36-.45.37-1.02.56-1.61.52-.45.01-.89-.09-1.29-.28-.4-.2-.74-.5-1-.86a4.48 4.48 0 01-.66-1.48c-.17-.7-.24-1.41-.23-2.13-.01-.72.07-1.43.24-2.13.13-.53.35-1.03.66-1.48.26-.37.6-.66 1-.86.4-.19.85-.29 1.29-.28.31-.01.61.04.91.14.25.09.49.22.7.39.21.17.38.37.53.6.15.24.28.5.39.76h.11V.19h2.43v13.03h-2.43l-.01-1.67zm-1.59-.16c.4.01.79-.11 1.11-.33.33-.25.51-.65.47-1.06V7.35c.04-.41-.14-.81-.47-1.06-.33-.22-.72-.34-1.11-.32-.48-.03-.95.17-1.27.53-.32.43-.48.95-.44 1.48v1.4c-.03.53.13 1.06.45 1.48.31.37.78.56 1.26.53zM104.11 13.43c-1.22.08-2.41-.38-3.24-1.27-.78-.98-1.17-2.2-1.1-3.45-.01-.68.09-1.35.29-2 .17-.56.45-1.07.82-1.52.35-.41.8-.74 1.3-.95.55-.22 1.13-.34 1.72-.33.59-.01 1.18.1 1.72.33.49.21.92.53 1.27.92.37.42.64.92.82 1.45.2.61.3 1.26.29 1.9v.78h-5.81v.16c-.08 1 .66 1.88 1.67 1.96.11.01.23.01.34 0 .45.01.9-.09 1.3-.31.36-.21.68-.49.94-.82l1.32 1.53c-.37.47-.85.86-1.38 1.13-.71.36-1.49.52-2.27.49zm-.2-7.64c-.48-.02-.94.17-1.27.52-.33.39-.49.89-.47 1.4v.14h3.44v-.14a2.06 2.06 0 00-.45-1.41c-.32-.35-.77-.53-1.25-.51z"
            />
          </g>
          <path
            fill="#5BBBA1"
            d="M64.285 22.938a.49.49 0 11-.49-.49c.13 0 .25.05.34.14.1.1.15.22.15.35M100.755 22.938a.49.49 0 11-.49-.49c.13 0 .25.05.34.14.1.1.15.22.15.35M70.505 22.938c0 .35-.28.64-.64.63a.63.63 0 01-.63-.64c0-.35.28-.63.63-.63.35.01.64.29.64.64M76.895 22.938c0 .47-.39.86-.86.86s-.86-.39-.86-.86.39-.86.86-.86c.23 0 .45.09.61.25.16.16.25.38.25.61M94.905 22.938c0 .47-.39.86-.86.86s-.86-.39-.86-.86.39-.86.86-.86c.23 0 .45.09.61.25.16.16.25.38.25.61M82.615 22.938c0 .35-.28.64-.64.63a.63.63 0 01-.63-.64c0-.35.28-.63.63-.63s.64.29.64.64M88.545 22.938a.38.38 0 11-.76 0 .38.38 0 01.76 0M106.645 22.938a.38.38 0 11-.76 0 .38.38 0 01.76 0"
          />
          <path
            fill="#243762"
            d="M63.695 28.978c.18.01.35-.04.5-.14.14-.1.22-.26.21-.43v-.46h-.6c-.46 0-.69.15-.69.46v.17c0 .12.06.24.16.3.13.08.27.11.42.11m1.61.63a.82.82 0 01-.56-.18.723.723 0 01-.24-.5h-.04c-.06.24-.21.45-.42.58-.23.14-.5.2-.76.19-.34.02-.66-.09-.91-.3-.24-.21-.36-.52-.35-.84-.02-.36.15-.7.44-.91.4-.22.85-.32 1.3-.29h.64v-.2a.75.75 0 00-.16-.52.736.736 0 00-.55-.18c-.2-.01-.4.04-.57.14-.15.09-.28.21-.38.35l-.61-.54c.15-.24.36-.43.62-.55.34-.15.7-.23 1.07-.21.45-.03.89.1 1.25.37.31.28.48.68.45 1.1v1.69h.42v.81l-.64-.01zM68.155 29.618v-3.89h1.12v.71h.04c.04-.11.1-.21.17-.31.14-.2.33-.35.56-.42.14-.05.28-.07.42-.07.18 0 .35.03.51.09.15.06.29.16.4.28.12.14.21.3.27.47.07.2.1.42.1.64v2.52h-1.13v-2.39c0-.5-.21-.75-.66-.75-.09 0-.17.01-.25.03a.65.65 0 00-.38.29c-.03.07-.05.16-.05.25v2.56l-1.12-.01zM76.935 25.728h1.14l-1.83 4.51c-.09.26-.25.48-.47.66-.23.16-.5.24-.78.23h-.77v-.87h.94l.24-.66-1.57-3.87h1.2l.57 1.64.35 1.13h.06l.34-1.13.58-1.64zM81.945 27.708c.18.02.36-.04.5-.17.1-.12.16-.27.15-.42v-.18a.573.573 0 00-.15-.42.71.71 0 00-.5-.17.61.61 0 00-.48.17c-.1.12-.16.27-.15.42v.18c-.01.15.05.31.15.42.12.13.3.18.48.17m1.12 2.39c0-.09-.04-.18-.12-.24-.14-.07-.3-.1-.46-.09h-1.33c-.1.08-.15.19-.15.32 0 .12.05.23.15.3.16.09.34.13.52.12h.66c.19.01.38-.02.56-.1.11-.06.17-.18.17-.31m1.06-.07c.02.38-.18.73-.52.91-.51.23-1.07.33-1.64.29-.31 0-.61-.02-.92-.06-.2-.03-.4-.09-.58-.19a.648.648 0 01-.3-.29.768.768 0 01-.09-.36c-.01-.19.06-.37.2-.5.16-.13.35-.22.55-.26v-.04a.962.962 0 01-.4-.21.542.542 0 01-.15-.4c-.01-.16.06-.32.19-.42.16-.1.33-.17.51-.21v-.05c-.22-.1-.41-.26-.54-.47-.13-.22-.2-.47-.19-.73 0-.21.04-.41.12-.6.08-.17.2-.31.35-.42.16-.12.34-.21.53-.26.23-.06.46-.09.69-.09.23 0 .46.03.69.08v-.21c0-.14.05-.28.16-.38.12-.11.28-.16.44-.15h.69v.82h-.94v.07c.2.1.37.26.49.46.12.21.18.45.18.7 0 .21-.04.41-.12.6-.08.16-.2.3-.35.42-.16.12-.34.21-.54.27-.23.06-.46.09-.7.09-.11 0-.22-.01-.33-.02-.1-.01-.2-.03-.3-.06-.05.03-.1.07-.14.11-.04.05-.06.11-.05.17 0 .05.01.1.04.14.03.04.08.06.12.08.06.02.12.03.18.04h1.1c.24 0 .48.02.71.08.17.05.34.13.48.24.13.1.22.22.28.36.06.14.08.3.08.45M88.035 26.438a.789.789 0 00-.58.21.82.82 0 00-.21.6v.06h1.57v-.06a.865.865 0 00-.21-.6.752.752 0 00-.57-.21m.09 3.27c-.55.04-1.09-.16-1.48-.54-.36-.41-.54-.94-.51-1.48 0-.29.04-.57.13-.85.08-.24.21-.46.38-.65.17-.18.37-.32.6-.41.51-.19 1.07-.19 1.57 0 .22.09.42.23.59.4.17.18.29.39.37.62.09.26.14.54.13.82v.33h-2.67v.07c-.01.23.08.45.23.61.19.16.44.25.69.23.21.01.41-.04.6-.13.16-.09.31-.21.42-.35l.6.66c-.17.2-.39.37-.64.48-.32.15-.68.22-1.03.21M92.285 29.618v-3.89h1.11v.71h.04c.05-.11.1-.21.17-.31.14-.2.33-.35.56-.42.14-.04.28-.07.42-.06.18 0 .35.03.51.09.15.06.29.16.4.28.12.13.2.29.26.46.07.21.1.42.09.64v2.52h-1.11v-2.39c0-.5-.22-.75-.66-.75-.09 0-.17.01-.25.03a.57.57 0 00-.22.11.542.542 0 00-.21.43v2.56l-1.11-.01zM100.235 29.708c-.28 0-.56-.04-.83-.14-.23-.09-.44-.22-.62-.4a1.9 1.9 0 01-.39-.64c-.18-.55-.18-1.15 0-1.7.08-.24.22-.45.39-.64.17-.18.38-.31.62-.4.26-.1.54-.14.82-.14.36-.02.72.07 1.03.26.26.17.46.41.59.69l-.86.46a1.29 1.29 0 00-.28-.38.706.706 0 00-.48-.15.759.759 0 00-.59.21c-.15.17-.22.38-.21.61v.64c-.01.22.07.44.21.61.32.27.77.3 1.11.07.13-.11.24-.24.31-.39l.85.48c-.14.28-.35.52-.61.69-.32.19-.69.28-1.06.26M106.125 26.438a.789.789 0 00-.58.21.82.82 0 00-.21.6v.06h1.57v-.06a.865.865 0 00-.21-.6.752.752 0 00-.57-.21m.09 3.27c-.55.04-1.09-.16-1.48-.54a2.11 2.11 0 01-.51-1.48c0-.29.04-.57.13-.85.08-.24.21-.46.38-.65.16-.18.37-.32.6-.41.25-.1.52-.14.79-.14s.53.04.78.14c.22.09.42.23.59.4.17.18.29.39.37.62.09.26.14.54.13.82v.33h-2.67v.07c-.01.23.07.45.23.61.19.17.44.25.69.24.21.01.41-.04.6-.13.16-.09.31-.21.42-.35l.6.66c-.17.2-.39.37-.64.48-.32.15-.68.22-1.03.21"
          />
          <g fill="#243762">
            <path
              d="M48 24.14h1.11v2.4h.05c.09-.22.23-.42.42-.58.21-.16.47-.24.74-.22.2 0 .4.04.59.12.18.08.34.2.46.36.14.19.24.41.3.64.14.6.14 1.22 0 1.82-.06.23-.16.44-.3.64-.12.16-.28.28-.46.36-.19.09-.39.13-.59.13-.27.01-.53-.07-.74-.23a1.36 1.36 0 01-.42-.58h-.05v.71h-1.12l.01-5.57zm1.84 4.79c.21.01.43-.07.58-.23.15-.18.22-.4.21-.64v-.6a.934.934 0 00-.21-.64.783.783 0 00-.58-.22c-.18 0-.36.05-.51.14-.15.1-.23.27-.21.45v1.14c-.02.18.06.35.21.45.15.1.33.15.51.15zM55.31 25.82h1.14l-1.83 4.52c-.09.25-.25.48-.46.65-.23.16-.5.24-.78.23h-.77v-.88h.94l.24-.65-1.57-3.87h1.2l.57 1.64.35 1.13h.07l.34-1.13.56-1.64z"
            />
          </g>
        </svg>
      </a>
      <div v-if="sessionResolved" class="s-header__right-side">
        <a href="javascript:void(0)" class="s-header__faq">
          <span class="s-header__faq-ico">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33" aria-hidden="true" focusable="false" role="img">
              <circle fill="#FFF" cx="16.5" cy="16.5" r="16.5" />
              <path
                fill="#243762"
                d="M16.561 9.891c-1.76-.07-3.42.81-4.35 2.3-.19.27-.13.63.13.83l1.09.83c.26.2.63.16.84-.1.43-.76 1.22-1.23 2.09-1.25.78 0 1.74.5 1.74 1.26 0 .57-.47.86-1.24 1.29-.9.5-2.08 1.13-2.08 2.69v.25c0 .34.27.61.61.61h1.83c.34 0 .61-.27.61-.61v-.15c0-1.08 3.17-1.13 3.17-4.06 0-2.21-2.29-3.89-4.44-3.89zm-.25 9.45c-.97 0-1.75.78-1.75 1.75s.78 1.75 1.75 1.75 1.75-.78 1.75-1.75c0-.96-.78-1.75-1.75-1.75z"
              />
            </svg>
          </span>
          <span class="s-header__faq-text"> Často kladené dotazy </span>
        </a>
        <div v-if="loggedCustomer" class="position-relative">
          <button class="s-login-drop" aria-haspopup="settings" @click="showMenu = !showMenu">
            <span class="s-u-visualy-hidden"> Uživatelské menu </span>
            <span class="s-login-drop__avatar"></span>
            <span class="s-login-drop__name">
              {{ loggedCustomer.name }} <span class="d-md-none">N.</span
              ><span class="d-none d-md-inline">{{ loggedCustomer.surname }}</span>
              <span class="s-login-drop__arrow"> </span>
            </span>
          </button>
          <nav v-if="showMenu" class="s-dropmenu" id="settings">
            <ul class="s-dropmenu__list">
              <li class="s-dropmenu__item">
                <router-link :to="{ name: 'ReservationsManagement' }" class="s-dropmenu__link">
                  Správa rezervací
                </router-link>
              </li>
              <li class="s-dropmenu__item">
                <router-link :to="{ name: 'ResetPassword' }" class="s-dropmenu__link"> Změnit heslo </router-link>
              </li>
              <li class="s-dropmenu__item">
                <span class="s-dropmenu__link" @click="logout"> Odhlásit se </span>
              </li>
            </ul>
          </nav>
        </div>

        <a v-else @click="showLogin = true" class="s-btn s-btn--header">
          <span class="s-btn__ico">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 25 25"
              width="25"
              height="25"
              aria-hidden="true"
              focusable="false"
              role="img"
            >
              <g transform="translate(-286.948 -483.948)">
                <circle fill="#FFF" cx="299.45" cy="496.45" r="12.5" />
                <path
                  fill="#5BBBA1"
                  d="M294.948 501.297v-1.17c0-1.28 2.1-2.33 4.68-2.33s4.67 1.05 4.67 2.33v1.17h-9.35zm2.34-7.01c0-1.29 1.05-2.34 2.34-2.34s2.34 1.05 2.34 2.34-1.05 2.34-2.34 2.34c-1.29 0-2.34-1.05-2.34-2.34z"
                />
              </g>
            </svg>
          </span>
          <span class="s-btn__text"> Přihlásit se </span>
        </a>
      </div>
    </div>

    <transition name="fade">
      <modal v-if="showLogin" :show-modal="showLogin" @close="handleCloseModal" @open="handleOpenModal">
        <div :class="{ 's-u-opacity-0': loginInProgress }">
          <h2 class="s-modal__title mb-5" id="dialog-1-title">PŘIHLÁŠENÍ</h2>
          <p v-if="loginError" class="s-modal__error">Nesprávné uživatelské jméno nebo heslo</p>
          <div class="mb-4">
            <label class="s-form__label d-block"> Přihlašovací jméno </label>
            <input type="text" class="s-form__input" v-model="loginUsername" />
          </div>
          <div>
            <label class="s-form__label d-block"> Heslo </label>
            <input type="password" class="s-form__input" v-model="loginPassword" />
          </div>
          <div class="s-modal__btn-box">
            <a class="s-btn" @click.prevent="customerLogin"> Přihlásit </a>
          </div>
        </div>

        <Loader v-if="loginInProgress" />
      </modal>
    </transition>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import Modal from '../../components/partials/Modal';
import Loader from '../../components/partials/loader';

import { XiteApiService } from '../../services/xite.api.service';

export default {
  name: 'HeaderComponent',

  components: {
    Modal,
    Loader,
  },

  data() {
    return {
      showMenu: false,
      showLogin: false,
      loginUsername: null,
      loginPassword: null,
      sessionToken: window.localStorage.getItem('sessionToken') ? window.localStorage.getItem('sessionToken') : null,
      sessionResolved: false,
      loginError: false,
      loginInProgress: false,
    };
  },

  computed: {
    ...mapGetters({ me: 'me/getMe', getCustomer: 'customers/getCustomer', customers: 'customers/getAllCustomers' }),

    loggedCustomer() {
      if (!this.me) {
        return null;
      }

      return this.me;
    },
  },

  methods: {
    ...mapActions('me', ['setMe', 'getMeData']),
    ...mapActions({ setFormForLoggedCustomer: 'orders/setFormForLoggedCustomer' }),

    logout() {
      XiteApiService.get('CustomerLeave', {
        session: this.sessionToken,
      }).then(() => {
        this.setMe(null);
        this.$router.push({ name: 'ReservationLocation' });
      });
    },

    handleCloseModal() {
      this.showLogin = false;
    },

    customerLogin() {
      this.loginInProgress = true;
      this.loginError = false;
      XiteApiService.get('CustomerEnter', {
        username: this.loginUsername,
        password: this.loginPassword,
        session: this.sessionToken,
      })
        .then(() => {
          this.resolveSession();
          this.loginInProgress = false;
        })
        .catch(() => {
          this.loginError = true;
          this.loginInProgress = false;
        });
    },

    resolveSession() {
      XiteApiService.get('SessionAcquire', {
        session: this.sessionToken,
      }).then(session => {
        window.localStorage.setItem('sessionToken', session.session[0]);
        this.sessionToken = session.session[0];

        let customerId = session.customer ? session.customer[0] : null;
        if (customerId) {
          this.getMeData(customerId).then(() => {
            this.showLogin = false;
            this.sessionResolved = true;
          });
        } else {
          this.sessionResolved = true;
        }
      });
    },
  },

  created() {
    this.resolveSession();
  },
};
</script>

<style scoped>

</style>
